module.exports = __webpack_public_path__ + "img/ic-email.0c7e83a7.svg";